<template>
    <div class="flex w-full justify-center items-center h-screen">
        <div class="container w-[28rem] bg-[#f8f4f3] p-8 rounded-md">
            <a href="#" class="flex justify-center items-center pb-4 border-b border-b-gray-800 mb-4">
                <!-- タイトル -->
                <img src="/Vertical_144px.png" alt="logo" style="width: 144px; height: 144px;" class="w-full">
            </a>
            
            <div class="text-center">
                <p class="text-base font-semibold text-gray-600">ネットワークエラーまたはサーバーが応答していない可能性があります</p>
                <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">エラーが発生しました</h1>
                <div class="mt-10 flex justify-center">
                    <a href="/login" class="w-full">
                        <el-button type="primary" class="w-full">ログイン</el-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ErrorPage'
});
</script>

<style scoped>
h1 {
    color: red;
}
</style>